import React from 'react'
import Panel, { PanelTitle } from 'components/layout/Panel'
import { Container, Faq, Spacer, Text } from 'roadie-ui'

export type FAQItem = {
  title: string
  body: string
}

type FAQSectionProps = {
  items: FAQItem[]
  sectionTitle?: string
}

const FAQSection: React.FC<FAQSectionProps> = ({ items, sectionTitle = 'FAQs' }) => (
  <>
    <PanelTitle>{sectionTitle}</PanelTitle>
    <Panel noPadding>
      <Container.Base $padding="1.6rem 2.4rem">
        {items.map((item, index) => (
          <React.Fragment key={item.title}>
            {index > 0 ? <Spacer $height="2.4rem" /> : null}
            <Faq title={item.title}>
              <Container.Base $padding="0 0 0 2.4rem">
                <Text.Body2 $color="neutral-darker">{item.body}</Text.Body2>
              </Container.Base>
            </Faq>
          </React.Fragment>
        ))}
      </Container.Base>
    </Panel>
  </>
)

export default FAQSection
